import React from "react";

const Nav = () => {
  return (
    <header className="main-header">
      <div className="header-sticky">
        <nav className="container">
          <div className="navbar navbar-expand-lg">
            
            {/* Logo */}
            <a className="navbar-brand home-logo" href="/">
              <img src="img/logo.png" alt="Logo" className="home-log" />
            </a>

            {/* Toggle Button */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => {
                const navbarCollapse = document.querySelector(".navbar-collapse");
                navbarCollapse.classList.toggle("show");
              }}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Main Menu */}
            <div className="collapse navbar-collapse main-menu">
              <div className="nav-menu-wrapper">
                <ul className="navbar-nav mr-auto" id="menu">
                  
                  <li className="nav-item">
                    <a className="nav-link" href="/">Home</a>
                  </li>

                  <li className="nav-item">
                    <a className="nav-link" href="about-us">About Us</a>
                  </li>

                  {/* MeHome Ideas */}
                  <li className="nav-item submenu">
                    <a className="nav-link" href="#">MeHome Ideas</a>
                    <ul>
                      <li><a className="nav-link" href="outdoor-designs">Outdoor Designs</a></li>
                      <li><a className="nav-link" href="landscape-designs">Landscape Designs</a></li>
                      <li><a className="nav-link" href="furniture-designs">Furniture Designs</a></li>
                    </ul>
                  </li>

                  {/* Explore Designs */}
                  <li className="nav-item submenu">
                    <a className="nav-link" href="#">Explore Designs</a>
                    <ul>
                      <li><a className="nav-link" href="one-bhk-interior-designs">1 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="two-bhkinterior-designs">2 BHK Interior Designs</a></li>
                      <li><a className="nav-link" href="three-bhk-interior-designs">3 BHK Interior Designs</a></li>
                    </ul>
                  </li>

                  {/* Interior Design */}
                  <li className="nav-item submenu">
                    <a className="nav-link" href="#">Interior Design</a>
                    <ul>
                      <li><a className="nav-link" href="kitchen-designs">Kitchen Designs</a></li>
                      <li><a className="nav-link" href="bedroom-designs">Bedroom Designs</a></li>
                      <li><a className="nav-link" href="dining-room-designs">Dining Room Designs</a></li>
                      <li><a className="nav-link" href="living-room-designs">Living Room Designs</a></li>
                      <li><a className="nav-link" href="decorative-units-designs">Decorative Units Designs</a></li>
                      <li><a className="nav-link" href="kids-room-designs">Kids Room Designs</a></li>
                    </ul>
                  </li>

                  {/* More */}
                  <li className="nav-item submenu">
                    <a className="nav-link" href="#">More</a>
                    <ul>
                      <li><a className="nav-link" href="what-we-do">What We Do</a></li>
                      <li><a className="nav-link" href="why-mehome">Why Mehome</a></li>
                      {/* <li><a className="nav-link" href="gallery">Gallery</a></li>
                      <li><a className="nav-link" href="blogs">Blogs</a></li> */}
                      <li><a className="nav-link" href="carrers">Carrers</a></li>
                    </ul>
                  </li>
                </ul>
              </div>

              {/* Contact Button */}
              <div className="header-btn d-inline-flex">
                <a href="contact-us" className="btn-default">Contact Us</a>
              </div>
            </div>

            {/* Navbar Toggle Placeholder */}
            <div className="navbar-toggle"></div>
          </div>
        </nav>

        {/* Responsive Menu Placeholder */}
        <div className="responsive-menu"></div>
      </div>
    </header>
  );
};

export default Nav;
